module.exports = __webpack_public_path__ + "static/media/why-swimmy.07df34a7.png";